var _circle, _circle2, _circle3, _circle4, _line, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    stroke: "#D91F05"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15.9997,
    r: 10.1667,
    stroke: "#D91F05"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15.9996,
    r: 5.9,
    stroke: "#D91F05"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15.9995,
    r: 2.13333,
    fill: "#D91F05"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15.4592,
    y1: 16.4915,
    x2: 26.5275,
    y2: 6.24215,
    stroke: "#D91F05"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6 4.26641V6.93307H28.2667L31.4667 4.26641H28.2667V1.06641L25.6 4.26641Z",
    fill: "#D91F05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal);
export default __webpack_public_path__ + "static/media/goal.265a484657fe88929f94d8705d1a74bc.svg";
export { ForwardRef as ReactComponent };